import React, { useEffect, useState, useRef } from "react";
import { Header, Grid, Divider, Button } from "semantic-ui-react";
import { useNavigate } from "react-router";
import axios from "axios";
import { BaseUrlInvoice } from "../formcomponents/Constants";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import { useDispatch } from "react-redux";
import { addData } from "../reducer/pdfDataSlice";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  pdf,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import Swal from "sweetalert2";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { userData } from "../store/userData";
const ListInvoiceWithCatIndia = (props) => {
  const disptch = useDispatch();
  const { categoryId } = props;
  const navigate = useNavigate();
  const createNew = () => {
    navigate(`/new-india-invoice/null/${categoryId}`);
  };
  const userDetail = userData();
  useEffect(() => {
    getinvoiceList();
  }, [disptch]);

  const [rowData, setrowData] = useState(null);
  const getinvoiceList = () => {
    const postObject = {
      categoryId: categoryId,
      getAll: categoryId === 0 ? true : false,
    };

    console.log("skxnmosncnscs", postObject);
    axios
      .post(BaseUrlInvoice + "accounts/listInvoice", postObject)
      .then((res) => {
        console.log("Invoice List", res.data);

        setRecordForTable(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setRecordForTable = (record) => {
    let tempRecord = [];

    for (let i = 0; i < record.length; i++) {
      tempRecord.push({
        invoiceId: record[i].invoiceId,
        invoiceName: record[i].invoiceName,
        status: getStatus(record[i].status),
        invoiceDate: record[i].invoiceDate
          ? new Date(record[i].invoiceDate).toLocaleDateString("en-GB")
          : "",
        invoiceNumber: record[i].invoiceNumber,
        reference: record[i].reference,
        branding: getBranding(record[i].branding),
        amountsAre: getamountsAre(record[i].amountsAre),

        taxRate: getTaxRate(record[i].itemList),
        subTotal: getSubTotal(record[i]),
        amount: getTotal(record[i].itemList),
      });
    }

    console.log("tempRecord", tempRecord);

    setrowData(tempRecord);
  };

  const getStatus = (idVal) => {
    if (idVal === 1) {
      return "TICKETS SEND";
    } else if (idVal === 2) {
      return "INVOICE GENERATED";
    } else if (idVal === 3) {
      return "AMOUNT RECEIVED";
    } else if (idVal === 4) {
      return "PENDING";
    } else if (idVal === 5) {
      return "PERFORMA INVOICE";
    } else {
    }
  };

  const getBranding = (record) => {
    if (record === 1) {
      return "Tax Exclusive";
    } else if (record === 1) {
      return "Tax Exclusive";
    } else if (record === 1) {
      return "Tax Exclusive";
    }
  };
  const getamountsAre = (record) => {
    if (record === 1) {
      return "Standard";
    } else if (record === 1) {
      return "Special Projects";
    } else if (record === 1) {
      return "Very Orange Invoice";
    }
  };

  const getTotal = (record) => {
    let total = 0;
    for (let i = 0; i < record.length; i++) {
      let sum = record[i].amount;
      total = total + sum;
    }
    return total;
  };
  const getSubTotal = (record) => {
    console.log("Final Toatl", record);
    let total = 0;
    for (let i = 0; i < record.itemList.length; i++) {
      let sum = record.itemList[i].taxRate;
      total = total + sum;
    }
    return record.totalAmount - total;
  };
  const getUnitPrice = (record) => {
    let unitprice = 0;
    for (let i = 0; i < record.length; i++) {
      let sum = record[i].unitPrice;
      unitprice = unitprice + sum;
    }
    return unitprice;
  };

  const getTaxRate = (record) => {
    let unitprice = 0;
    for (let i = 0; i < record.length; i++) {
      let sum = record[i].taxRate;
      unitprice = unitprice + sum;
    }
    return unitprice;
  };
  const columnDefs = [
    { headerName: "ID ", field: "invoiceId", flex: 2 },
    { headerName: "Date ", field: "invoiceDate", flex: 4 },
    { headerName: "To", field: "invoiceName", flex: 5 },

    { headerName: "Status", field: "status", flex: 3 },
    // { headerName: "AmountsAre", field: "amountsAre", flex: 3 },
    {
      field: "invoiceNumber",
      headerName: "Number",
      flex: 4,
      cellRendererFramework: (params) => (
        <div style={{ cursor: "pointer" }} onClick={() => actionButton(params)}>
          {params.value}
        </div>
      ),
    },

    { headerName: "Reference", field: "reference", flex: 3 },
    { headerName: "Sub Total", field: "subTotal", flex: 3 },
    { headerName: "Tax", field: "taxRate", flex: 3 },
    { headerName: "Total", field: "amount", flex: 3 },

    {
      headerName: "Actions",
      filter: false,
      field: "invoiceId",
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => actionButton(params)}>
            View{" "}
          </Button>
          {userDetail.userRole == 1 && (
            <Button color="red" onClick={() => deleteItem(params)}>
              delete
            </Button>
          )}
        </div>
      ),
    },
  ];

  const deleteItem = (params) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire("Deleted!", "Your file has been deleted.", "success");
        axios
          .post(BaseUrlInvoice + "accounts/deleteInvoice", {
            invoiceId: params.data.invoiceId,
          })
          .then((res) => {
            console.log(res.data);
            Swal.fire("Deleted!", "Invoice has been deleted.", "success");
            getinvoiceList();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };
  const actionButton = (params) => {
    console.log(params.data.dailyWorkId);
    navigate(`/new-india-invoice/${params.data.invoiceId}/${categoryId}`);
    // history.push(
    //   `/attraction/attraction-creation/${params.data.attractionsId}`
    // ); /
  };

  const defaultColDef = {
    sortable: true,
    editable: false,
    // flex: 1,
    filter: true,
    floatingFilter: true,
  };

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <div>
      <Grid.Row>
        {/* <Header dividing size="huge" as="h1">
          Invoice List
        </Header> */}
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <div>
          <Button type="submit" primary onClick={() => createNew()}>
            Create New
          </Button>

          {rowData !== null && (
            <Button
              color="primary"
              onClick={(e) => exportToCSV(rowData, "Invoice_List")}
            >
              Download CSV
            </Button>
          )}
        </div>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <div className="ag-theme-alpine" style={{ height: 600 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
          ></AgGridReact>
        </div>
      </Grid.Row>
    </div>
  );
};

export default ListInvoiceWithCatIndia;
